import axios from 'axios';
import { supabase } from '../supabaseClient';

async function getAllPlansByProject(projectId) {
    let query = supabase.from('PaymentPlans').select('*,inventoryTypeId(*),wingId(*)', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

// isVJ === false routes to the JD Farvision API (JDPROJECT DB); anything else keeps the VJ route.
async function getAllPlansByProjectFromFarvision(buId, isVJ) {
    const baseUrl = isVJ === false ? process.env.REACT_APP_JDPROJECTS_URL : process.env.REACT_APP_PROJECTS_URL;
    return await axios.get(`${baseUrl}paymentPlan?buId=${buId}`);
}


async function getAllPricingByProject(projectId) {
    let query = supabase.from('ProjectPricing').select('*,inventoryTypeId(*),wingId(*)', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getAllPlansByLaunch(launchId) {
    let query = supabase.from('LaunchPaymentPlanRelations').select('*', { count: 'exact' }).eq('launchId', launchId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getAllPricingPlansByLaunch(launchId, wingId) {
    let query = supabase.from('LaunchPricingRelations')
        .select('*,projectPricingId(*)', { count: 'exact' })
        .eq('launchId', launchId)
        .eq('projectPricingId.wingId', wingId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getAllPricingPlansByProjectId(projectId, wingId) {
    let query = supabase.from('SustenancePricingRelations')
        .select('*,projectPricingId(*)', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('projectPricingId.wingId', wingId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getAllPaymentsPlansByLaunch(launchId, wingId) {
    let query = supabase.from('LaunchPaymentPlanRelations')
        .select('*,paymentPlanId(*)', { count: 'exact' })
       .eq('launchId', launchId)
     .eq('paymentPlanId.wingId', wingId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getAllPaymentPlansByProjectId(projectId, wingId) {
    let query = supabase.from('SustenancePaymentPlanRelations')
        .select('*,paymentPlanId(*)', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('paymentPlanId.wingId', wingId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getAllPricingByLaunch(launchId) {
    let query = supabase.from('LaunchPricingRelations').select('*', { count: 'exact' }).eq('launchId', launchId)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getAllPaymentPlans(projectId, wingId,displayUnitType) {
    let query = supabase.from('PaymentPlans')
        .select('*', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        .eq("displayUnitType",displayUnitType)
        .eq("isDisabled", false)
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

export { getAllPlansByProject, getAllPlansByProjectFromFarvision, getAllPlansByLaunch, getAllPricingPlansByLaunch, getAllPricingByProject, 
    getAllPricingByLaunch, getAllPricingPlansByProjectId,getAllPaymentsPlansByLaunch,getAllPaymentPlansByProjectId, getAllPaymentPlans }
